import { TableColumn, TableColumnType } from '@thehubz/client/core';

export class VorwerkTableColumnData {
  /* Default table column configurations */
  static TABLE_DEFAULT_COLUMNS: TableColumn[] = [
    {
      sequence: 1,
      columnDef: 'checked',
      header: $localize`Checkbox`,
      type: TableColumnType.checkbox,
      class: 'w-[auto] grow-0',
      filter: false,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
      sticky: true,
    },
    {
      sequence: 2,
      columnDef: 'coverAssetID',
      header: $localize`Preview`,
      type: TableColumnType.collectionPreview,
      class: 'w-[13vw] min-w-[9rem] pl-4 grow-0',
      filter: false,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
    },
    {
      sequence: 3,
      columnDef: 'name',
      header: $localize`Name`,
      class: 'w-[20rem] pl-4',
      filter: false,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
    },
    {
      sequence: 4,
      columnDef: 'assets',
      type: TableColumnType.assetCount,
      header: $localize`Number of Assets`,
      class: 'w-[10%] min-w-[10rem] whitespace-nowrap',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
    },

    {
      sequence: 5,
      columnDef: 'keywords',
      type: TableColumnType.tags,
      header: $localize`Tags`,
      class: 'w-[9%] min-w-[9rem]',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
    },
    {
      sequence: 6,
      columnDef: 'ownerIDs',
      type: TableColumnType.owners,
      header: $localize`Owners`,
      class: 'w-[9%] min-w-[9rem]',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
    },
    {
      sequence: 7,
      columnDef: 'createdAt',
      type: TableColumnType.date,
      header: $localize`Created at`,
      class: 'w-[8%] min-w-[8rem] whitespace-nowrap',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
    },
    {
      sequence: 8,
      columnDef: 'createdBy',
      type: TableColumnType.createdByUserIcon,
      header: $localize`Created by`,
      class: 'w-[8%] min-w-[8rem] whitespace-nowrap',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
    },
    {
      sequence: 9,
      columnDef: 'updatedAt',
      type: TableColumnType.date,
      header: $localize`Last updated`,
      class: 'w-[8%] min-w-[6rem] whitespace-nowrap',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
    },
  ];
  /* Additional columns configurations */
  static ADD_COLUMNS: TableColumn[] = [
    {
      sequence: 10,
      columnDef: 'agency',
      header: $localize`Domain`,
      class: 'w-[10%] min-w-[10rem] hide-icon',
      filter: false,
      filterSelected: 0,
      type: TableColumnType.name,
      visible: false,
      columnType: 'additional',
    },
    {
      sequence: 11,
      columnDef: 'client',
      header: $localize`Location`,
      type: TableColumnType.name,
      class: 'w-[10%] min-w-[10rem] hide-icon',
      filter: false,
      filterSelected: 0,
      visible: false,
      columnType: 'additional',
    },
    {
      sequence: 12,
      columnDef: 'brand',
      header: $localize`Brand`,
      type: TableColumnType.name,
      class: 'w-[10%] min-w-[10rem] hide-icon',
      filter: false,
      filterSelected: 0,
      visible: false,
      columnType: 'additional',
    },
  ];
}
